import { COMPONENT_VALUE_TYPES as types, COMPONENT_COLOR_THEMES } from 'shared/constants';

const propsSchema = [
  {
    key: 'text',
    label: 'Text',
    type: types.TEXTAREA
  },
  {
    key: 'color_theme',
    label: 'Color Theme',
    type: types.ENUM,
    options: COMPONENT_COLOR_THEMES
  },
  {
    key: 'background_color',
    label: 'Background Color',
    type: types.COLOR_PICKER
  }
];

const defaultProps = {
  text: 'We are starting with a clean slate, and are more able to tackle challenges such as autonomous driving and battery range with a novel, uninhibited approach.',
  color_theme: 'LIGHT',
  background_color: '#f7f7f7'
};

export default {
  title: 'Section Paragraph',
  id: 'SectionParagraph',
  propsSchema,
  defaultProps
};
